(function() {
    'use strict';
    angular
        .module('ordiniApp')
        .factory('DettaglioOrdine', DettaglioOrdine);

    DettaglioOrdine.$inject = ['$resource', 'DateUtils'];

    function DettaglioOrdine ($resource, DateUtils) {
        var resourceUrl =  'api/dettaglio-ordines/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dataCreazione = DateUtils.convertDateTimeFromServer(data.dataCreazione);
                        data.dataAggiornamento = DateUtils.convertDateTimeFromServer(data.dataAggiornamento);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
